export enum NodeType {
  UNKNOWN_NODE = 0,
  OPERATIVE_NODE = 1,
  SWEEPER_NODE = 2,
  TRANSPORT_NODE = 3,
  VEHICLE_NODE = 4,
}

export enum NodeTypeApiValue {
  UNKNOWN_NODE = 'UNKNOWN_NODE',
  OPERATIVE_NODE = 'OPERATIVE_NODE',
  SWEEPER_NODE = 'SWEEPER_NODE',
  TRANSPORT_NODE = 'TRANSPORT_NODE',
  VEHICLE_NODE = 'VEHICLE_NODE',
}

export const NodeTypeLabel: Record<NodeType, string> = {
  [NodeType.UNKNOWN_NODE]: 'Unknown',
  [NodeType.OPERATIVE_NODE]: 'Operative',
  [NodeType.SWEEPER_NODE]: 'Sweeper',
  [NodeType.TRANSPORT_NODE]: 'Transport',
  [NodeType.VEHICLE_NODE]: 'Vehicle',
};
